const Taks = [
  {
    id: 1,
    title: "فصل صفرم : مقدمات",
    sublist: [
      {
        id: 1,
        time: "20:01",
        description: "معرفی دوره مصور سازی با پایتون",
      },
      {
        id: 2,
        time: "26:44",
        description: "نصب دفترچه ژوپیتر",
      },
      {
        id: 3,
        time: "09:34",
        description: "دیتا ست چیست؟",
      },
    ],
    open: false,
  },
  {
    id: 2,
    title: "فصل اول :آشنایی و کار با نامپی",
    sublist: [
      {
        id: 1,
        time: "13:22",
        description: "نامپی چیست",
      },
      {
        id: 2,
        time: "24:09",
        description: "ساخت آرابه از اشیا و صفات آن",
      },
      {
        id: 3,
        time: "11:46",
        description: "ساخت آرایه با مقادیر پیش فرض",
      },
      {
        id: 4,
        time: "08:42",
        description: "عملگر های آرایه",
      },
      {
        id: 5,
        time: "04:20",
        description: "متد های آماری مهم",
      },
    ],

    open: false,
  },
  {
    id: 3,
    title: "فصل دوم : آشنایی و کار با پانداس",
    sublist: [
      {
        id: 1,
        time: "08:43",
        description: "آشنایی با پانداس و سری",
      },
    ],

    open: false,
  },
];

export default Taks;
